import http from '@/http'
const URL = '/admin/hotels/accommodations'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const typesAccommodations = async (params) => {
  const list = (await http.get(URL + '/typeAccommodations', { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=category`))
  }
  return one
}

export const saveAccommodation = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const delAccommodation = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  typesAccommodations,
  show,
  saveAccommodation,
  delAccommodation
}
